module.exports = __webpack_public_path__ + "static/media/s3.65c61e60.jpg";